import { IKeyValue } from "motw_core/Entity/IKeyValue";
import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import * as React from "react";
import { UpdateKeyValueAsync } from "source/app/infrastructure/Data/KeyValues/UpdateKeyValue";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import { useIntervalToRerender } from "source/app/services/Shared/Hooks/useIntervalToRerender";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { IsToday } from "source/app/services/Time/Time";

export function ResetCICOValue({
    sharedFunction,
    keyValue,
}: {
    sharedFunction: ESharedFunction;
    keyValue: IKeyValue;
}) {
    const isResetRequired = !IsToday(keyValue.lastmodifiedtime);

    const thirtyMinutesInMs = 30 * 60 * 1000;
    useIntervalToRerender(thirtyMinutesInMs);

    return (
        <span
            style={{
                opacity: 0.5,
                position: `absolute`,
                marginLeft: `5px`,
                color: isResetRequired ? `coral` : `inherit`,
            }}
        >
            <IconWithText
                iconSuffix={EGlyphicon.refresh}
                whenClicked={async () => {
                    await UpdateKeyValueAsync(sharedFunction, `0`);
                }}
                displayAsBlock={false}
                tooltip={isResetRequired ? `Reset required` : `Reset`}
            />
        </span>
    );
}
